import React, { useState } from "react";
import { BubbleMenu } from "@tiptap/react";
import { useTranslation } from "react-i18next";
import { SlNote } from "react-icons/sl";
import { useWebSocket } from "../../../../contexts/WebSocketContext";
import { notImage } from "../helper";
import RephraseModal from "./rephrase-modal";

const RephraseBubbleMenu = ({ editor }) => {
  const { t } = useTranslation();
  const { setOpenRephraseModal, openRephraseModal } = useWebSocket();
  const [selectedHTML, setSelectedHTML] = useState("");
  const [selectionRange, setSelectionRange] = useState({ from: 0, to: 0 });

  const isContentZone = (node) => {
    if (!node || node?.name === "doc") return false;
    if (node?.name === "contentzone") return true;
    return isContentZone(node.parent);
  };

  const handleRephrase = () => {
    if (!editor) return;
    const { from, to } = editor.state.selection;
    if (from === to) return;

    const view = editor.view;
    const startDOM = view.domAtPos(from).node;
    const endDOM = view.domAtPos(to).node;
    const range = document.createRange();
    range.setStartBefore(startDOM);
    range.setEndAfter(endDOM);
    const fragment = range.cloneContents();
    const div = document.createElement("div");
    div.appendChild(fragment);

    setSelectedHTML(div.innerHTML);
    setSelectionRange({ from, to });
    setOpenRephraseModal(true);
  };

const sanitizeInline = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const handleSaveRephrase = (rephrasedHTML) => {
  if (!editor) return;
  const { from, to } = selectionRange || editor.state.selection;
  if (from === undefined || to === undefined) return;

  const inlineText = sanitizeInline(rephrasedHTML);

  editor
    .chain()
    .focus()
    .insertContentAt({ from, to }, { type: "text", text: inlineText })
    .run();

  setOpenRephraseModal(false);
};

  return (
    <div>
      <BubbleMenu
        editor={editor}
        tippyOptions={{ duration: 100, offset: [0, 20] }}
        shouldShow={({ state }) => {
  const { from, to } = state.selection;
  const doc = state.doc;
  if (from === to) return false; // no selection

  // Get the parent zone of the selection
  let zoneType = null;
  doc.nodesBetween(from, from, (node) => {
    if (node.type.name.endsWith("zone")) { // e.g., h1zone, introzone, contentzone, conclusionzone
      zoneType = node.type.name;
      return false;
    }
  });

  // Must be more than 1 word
  const text = doc.textBetween(from, to, " ").trim();
  const wordCount = text.split(/\s+/).length;
  if (wordCount <= 1) return false;

  // Content zone: don't show if heading
  if (zoneType === "contentzone") {
    let hasHeading = false;
    doc.nodesBetween(from, to, (node) => {
      if (node.type.name === "heading") {
        hasHeading = true;
        return false;
      }
    });
    if (hasHeading) return false;
  }

  // Other zones: show normally
  return true;
}}

      >
        <div className="min-w-[200px] text-sm bg-neutral-500 text-white rounded-md flex flex-col">
          <button
            onClick={handleRephrase}
            className="p-2 hover:bg-neutral-600 rounded-md flex items-center gap-4"
          >
            <SlNote />
            {t("Rewrite-Selection", "Rewrite Selection")}
          </button>
        </div>
      </BubbleMenu>

      {openRephraseModal && (
        <RephraseModal
          selectedHTML={selectedHTML}
          onSave={handleSaveRephrase}
        />
      )}
    </div>
  );
};

export default RephraseBubbleMenu;
